(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-carrusel-colecciones"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCollectionsCarousel(root) {
      var viewport = root.querySelector('[data-viewport]');
      var prevArrow = root.querySelector('[data-arrow-prev]');
      var nextArrow = root.querySelector('[data-arrow-next]');
      if (!viewport || !prevArrow || !nextArrow) return;

      function toggleArrow(arrow, visible) {
        arrow.classList.toggle('is-visible', visible);
        arrow.setAttribute('aria-hidden', visible ? 'false' : 'true');
        arrow.tabIndex = visible ? 0 : -1;
      }

      function updateArrows(scrollLeftOverride) {
        var scrollLeft = typeof scrollLeftOverride === 'number' ? scrollLeftOverride : viewport.scrollLeft;
        var maxScroll = viewport.scrollWidth - viewport.clientWidth;
        var canScroll = maxScroll > 1;
        var atStart = scrollLeft <= 1;
        var atEnd = scrollLeft >= maxScroll - 1;

        toggleArrow(prevArrow, canScroll && !atStart);
        toggleArrow(nextArrow, canScroll && !atEnd);
      }

      // Posición de scroll en la que cada tarjeta queda pegada a la izquierda.
      // La primera respeta el relleno del inicio (20px). Las demás se alinean a
      // un espacio igual al gap, así la tarjeta anterior sale completa y no
      // asoma ningún pedacito por la orilla.
      function getSnapPositions() {
        var list = viewport.querySelector('.collections-carousel__list');
        var listStyle = list ? window.getComputedStyle(list) : null;
        var pad = listStyle ? parseFloat(listStyle.paddingLeft) || 0 : 0;
        var gap = listStyle ? parseFloat(listStyle.columnGap) || 0 : 0;
        var viewportLeft = viewport.getBoundingClientRect().left;
        var positions = [];

        root.querySelectorAll('.collections-carousel__item').forEach(function (item, index) {
          var left = item.getBoundingClientRect().left - viewportLeft + viewport.scrollLeft;
          var inset = index === 0 ? pad : gap;
          positions.push(Math.max(Math.round(left - inset), 0));
        });

        return { positions: positions, gap: gap };
      }

      function scrollToward(direction) {
        var maxScroll = viewport.scrollWidth - viewport.clientWidth;
        var current = viewport.scrollLeft;
        var snap = getSnapPositions();
        var positions = snap.positions;
        var items = root.querySelectorAll('.collections-carousel__item');
        var target = current;
        var i;

        if (direction > 0) {
          // Siguiente: la primera tarjeta que no se ve completa pasa a quedar al inicio
          target = maxScroll;
          var viewportRight = viewport.getBoundingClientRect().right;
          for (i = 0; i < items.length; i++) {
            if (items[i].getBoundingClientRect().right > viewportRight + 1 && positions[i] > current + 2) {
              target = positions[i];
              break;
            }
          }
        } else {
          // Anterior: regresa lo que cabe en una pantalla, siempre con una tarjeta pegada al inicio
          target = 0;
          var limit = current - viewport.clientWidth + snap.gap * 2;
          for (i = 0; i < positions.length; i++) {
            if (positions[i] >= limit && positions[i] < current - 2) {
              target = positions[i];
              break;
            }
          }
        }

        target = Math.min(Math.max(target, 0), maxScroll);
        viewport.scrollTo({ left: target, behavior: 'smooth' });
        updateArrows(target);
      }

      prevArrow.addEventListener('click', function () { scrollToward(-1); });
      nextArrow.addEventListener('click', function () { scrollToward(1); });

      viewport.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);

      var isDown = false;
      var dragged = false;
      var startX = 0;
      var startScrollLeft = 0;

      viewport.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isDown = true;
        dragged = false;
        startX = e.clientX;
        startScrollLeft = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
      });

      document.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var delta = e.clientX - startX;
        if (Math.abs(delta) > 3) dragged = true;
        if (dragged) e.preventDefault();
        viewport.scrollLeft = startScrollLeft - delta;
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        viewport.classList.remove('is-dragging');
        updateArrows();
      }

      document.addEventListener('pointerup', endDrag);
      document.addEventListener('pointercancel', endDrag);

      viewport.addEventListener('click', function (e) {
        if (dragged) {
          e.preventDefault();
          e.stopPropagation();
          dragged = false;
        }
      }, true);

      var HOVER_GROWTH = 150;

      function handlePointerEnter(e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        if (window.matchMedia('(max-width: 749px)').matches) return;

        var item = e.currentTarget;
        var itemRect = item.getBoundingClientRect();
        var viewportRect = viewport.getBoundingClientRect();
        var maxScroll = viewport.scrollWidth - viewport.clientWidth;

        var overflowRight = (itemRect.right + HOVER_GROWTH) - viewportRect.right;
        var overflowLeft = viewportRect.left - itemRect.left;

        if (overflowRight > 0) {
          var target = Math.min(viewport.scrollLeft + overflowRight, maxScroll);
          viewport.scrollTo({ left: target, behavior: 'smooth' });
        } else if (overflowLeft > 0) {
          var target2 = Math.max(viewport.scrollLeft - overflowLeft, 0);
          viewport.scrollTo({ left: target2, behavior: 'smooth' });
        }
      }

      root.querySelectorAll('.collections-carousel__item').forEach(function (item) {
        item.addEventListener('pointerenter', handlePointerEnter);
      });

      updateArrows();
    }

    document.querySelectorAll('[data-collections-carousel]').forEach(initCollectionsCarousel);

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-collections-carousel]');
      if (root) {
        initCollectionsCarousel(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-colecciones-destacadas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFeaturedCollections(root) {
      var tabs = root.querySelectorAll('[data-tab]');
      var panels = root.querySelectorAll('[data-panel]');
      var cta = root.querySelector('[data-cta]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var index = tab.getAttribute('data-index');

          tabs.forEach(function (t) {
            var isActive = t === tab;
            t.classList.toggle('is-active', isActive);
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach(function (panel) {
            var isActive = panel.getAttribute('data-index') === index;
            panel.classList.toggle('is-active', isActive);
            if (isActive) {
              panel.removeAttribute('hidden');
            } else {
              panel.setAttribute('hidden', '');
            }
          });

          if (cta) {
            var url = tab.getAttribute('data-collection-url');
            if (url) {
              cta.setAttribute('href', url);
            }
          }
        });
      });
    }

    document.querySelectorAll('[data-featured-collections]').forEach(initFeaturedCollections);

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-featured-collections]');
      if (root) {
        initFeaturedCollections(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-collection-nav"]) return;
  try {
    
  (function () {
    function initCollectionNav(root) {
      var viewport = root.querySelector('[data-collection-nav-viewport]');
      var arrow = root.querySelector('[data-collection-nav-arrow]');
      if (!viewport || !arrow) return;

      function checkOverflow() {
        var hasOverflow = viewport.scrollWidth > viewport.clientWidth + 2;
        root.classList.toggle('has-overflow', hasOverflow);
      }

      arrow.addEventListener('click', function () {
        viewport.scrollBy({ left: viewport.clientWidth * 0.6, behavior: 'smooth' });
      });

      checkOverflow();
      window.addEventListener('resize', checkOverflow);

      var active = viewport.querySelector('.is-active');
      if (active) {
        active.scrollIntoView({ inline: 'center', block: 'nearest' });
      }
    }

    document.querySelectorAll('[data-collection-nav]').forEach(initCollectionNav);

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-collection-nav]');
      if (root) {
        initCollectionNav(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-mm-tab]');
    if (!tab) return;

    var root = tab.closest('.section-resource-list');
    if (!root) return;

    var targetId = tab.getAttribute('data-mm-tab-target');

    root.querySelectorAll('[data-mm-tab]').forEach(function (otherTab) {
      var isTarget = otherTab === tab;
      otherTab.classList.toggle('is-active', isTarget);
      otherTab.setAttribute('aria-selected', isTarget ? 'true' : 'false');
    });

    root.querySelectorAll('.mm-featured-tabs__panel').forEach(function (panel) {
      var isTarget = panel.id === targetId;
      panel.classList.toggle('is-active', isTarget);
      panel.toggleAttribute('hidden', !isTarget);
    });

    var cta = root.querySelector('[data-mm-cta]');
    var tabUrl = tab.getAttribute('data-mm-tab-url');
    if (cta && tabUrl) {
      cta.setAttribute('href', tabUrl);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
